import React from "react";
import { withRouter } from "../_shared/withRouter";
import LoginComponent from "../template/auth/loginComponent";

const AdminLogin = () => {
  return <LoginComponent roleType={"admin"} role={"2"} />;
};

export default withRouter(AdminLogin);
